<template>
  <router-link :class="`border-${message.borderColor}`"
               :to="apiCallDetailLink"
               class="grid grid-cols-5 col-span-5 pt-4 border-solid border-0 border-l-2 pr-3"
               @click.native="selectBubble">
    <api-call-placeholder :focus="isSelected" :label="label" class="col-span-3 col-start-4"/>
  </router-link>
</template>

<script>
import ApiCallPlaceholder from '@/components/common/ApiCallPlaceholder'

export default {
  name: 'ConversationApiCall',

  components: { ApiCallPlaceholder },

  props: {
    message: {
      type: Object,
      required: true
    },
    selectedBubble: {
      type: Object,
      default: null
    }
  },

  emits: ['bubble-selected'],

  computed: {
    // Tool calls share the remote_action event type; `remoteAction.type` tells them apart, so a call the
    // AI decided to make is not shown as one the bot author placed in the flow.
    label() {
      const remoteAction = (this.message.data || {}).remoteAction || {}
      return remoteAction.type === 'tool' ? `Tool: ${remoteAction.name}` : 'API call'
    },

    isSelected() {
      return this.selectedBubble && this.selectedBubble.messageId === this.message.id
    },

    apiCallDetailLink() {
      return {
        name: this.$route.name,
        params: this.$route.params,
        query: { ...this.$route.query, messageId: this.message.id, requestId: undefined }
      }
    }
  },

  methods: {
    selectBubble() {
      this.$emit('bubble-selected')
    }
  }
}
</script>
